import React from 'react';
import authService from '../services/authService';
import withRouter from './withRouter';
import { BrowserRouter as Router, Route, Navigate , Routes, Link, Outlet, useLocation } from 'react-router-dom';

const Private = ({ component: Component }) => {
  let location = useLocation();
  const isAuth = authService.isLoggedIn();
  
  return isAuth ? (
    <Component />
  ) : (
    <Navigate
      to={{
        pathname: "mobile/authenticate",
        state: { from: location.pathname },
      }}
    />
  );
};

export { Router, Route, Navigate , Routes, Private, withRouter, Link, Outlet };